export default "__VITE_ASSET__e591eb41__"